var _path, _g, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_694_13974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00024 2.01172H20.0529V21.8652H3.00024V2.01172Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_694_13974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57335 3.51172C5.91635 3.51172 4.54035 4.85372 4.50135 6.50872V17.2037C4.46435 18.9167 5.81435 20.3277 7.51035 20.3657H15.5743C17.2433 20.2967 18.5653 18.9097 18.5533 17.2097V8.33972L13.9183 3.51172H7.58535H7.57335ZM7.58535 21.8657H7.47635C4.95435 21.8087 2.94635 19.7107 3.00135 17.1877V6.49072C3.05935 4.00972 5.10835 2.01172 7.57135 2.01172H7.58835H14.2383C14.4423 2.01172 14.6373 2.09472 14.7793 2.24172L19.8443 7.51872C19.9783 7.65772 20.0533 7.84472 20.0533 8.03772V17.2037C20.0713 19.7127 18.1173 21.7627 15.6043 21.8647L7.58535 21.8657Z",
    fill: "#505050"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2983 8.984H16.5433C14.7133 8.979 13.2253 7.487 13.2253 5.659V2.75C13.2253 2.336 13.5613 2 13.9753 2C14.3893 2 14.7253 2.336 14.7253 2.75V5.659C14.7253 6.663 15.5423 7.481 16.5453 7.484H19.2983C19.7123 7.484 20.0483 7.82 20.0483 8.234C20.0483 8.648 19.7123 8.984 19.2983 8.984Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7887 16.1074H8.38867C7.97467 16.1074 7.63867 15.7714 7.63867 15.3574C7.63867 14.9434 7.97467 14.6074 8.38867 14.6074H13.7887C14.2027 14.6074 14.5387 14.9434 14.5387 15.3574C14.5387 15.7714 14.2027 16.1074 13.7887 16.1074Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7437 12.3555H8.3877C7.9737 12.3555 7.6377 12.0195 7.6377 11.6055C7.6377 11.1915 7.9737 10.8555 8.3877 10.8555H11.7437C12.1577 10.8555 12.4937 11.1915 12.4937 11.6055C12.4937 12.0195 12.1577 12.3555 11.7437 12.3555Z",
    fill: "#505050"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIcon);
export default __webpack_public_path__ + "static/media/paperIcon.f520e2931faf90e0320797325da2882e.svg";
export { ForwardRef as ReactComponent };